var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('the-honor',{attrs:{"data":_vm.honor}})}
var staticRenderFns = []

export { render, staticRenderFns }